// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2353":"72ed8f4e","3977":"74c49c1d","8140":"447533d2","8281":"6522b0e6"}[chunkId] + ".chunk.css";
};